module.exports = __webpack_public_path__ + "img/6.ba404cf9.jpg";